import { useCallback, Dispatch, SetStateAction } from 'react';
import { FilterType } from '@app/api';

export interface FilterData {
  field: string;
  type: FilterType;
  values: string[];
  min?: number | Date;
  max?: number | Date;
}

export const useParticipationFilters = (
  setFilters: Dispatch<SetStateAction<FilterData[]>>,
) => {
  return useCallback(
    (
      field: string,
      type: FilterType,
      values: string[],
      min?: number | Date,
      max?: number | Date,
    ) => {
      if (values.length === 0 && !min && !max) {
        setFilters((prev) => prev.filter((f) => f.field !== field));
      } else {
        setFilters((prev) => {
          const existing = prev.find((f) => f.field === field);
          const newFilter: FilterData = { field, type, values };
          if (min) {
            newFilter.min = min;
          }
          if (max) {
            newFilter.max = max;
          }
          if (existing) {
            return prev.map((f) => (f.field === field ? newFilter : f));
          }
          return [...prev, newFilter];
        });
      }
    },
    [setFilters],
  );
};
